import {Component, forwardRef, Input, OnInit} from '@angular/core';
import {ParameterBase} from '~/app/core/reports/models/ParameterBase';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';

@Component({
  selector: 'app-date-range',
  templateUrl: './date-range.component.html',
  styleUrls: ['./date-range.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DateRangeComponent),
      multi: true
    }
  ]
})
export class DateRangeComponent implements ControlValueAccessor {
  get start(): Date {
    return this._start;
  }

  set start(value: Date) {
    this._start = value;
    this.value = {start: this.start, end: this.end};
  }

  get end(): Date {
    return this._end;
  }

  set end(value: Date) {
    this._end = value;
    this.value = {start: this.start, end: this.end};
  }

  @Input()
  param: ParameterBase<string>;

  private _start = new Date();
  private _end = new Date();

  // tslint:disable-next-line:no-input-rename
  @Input('value') private _value = {start: new Date(), end: new Date()};
  onChange: any = () => {};
  onTouched: any = () => {};

  constructor() { }

  get value(): { start: Date; end: Date } {
    return this._value;
  }

  set value(val: { start: Date; end: Date }) {
    this._value = val;
    this.onChange(val);
    this.onTouched();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  writeValue(val: any): void {
    if (val) {
      this.value = val;
    }
  }

}
